import {
  DatabaseService,
  Inventory,
  InventoryData,
  InventoryRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getInventoryRepository(
  databaseService: DatabaseService,
): InventoryRepository {
  return getGenericRepository<Inventory, InventoryData>(
    () => DatabaseCollection.INVENTORIES,
    databaseService,
  );
}
